/**
 * Focal-point position stored as CSS object-position percentages.
 * x: 0 = left edge, 100 = right edge, 50 = centre
 * y: 0 = top edge, 100 = bottom edge, 50 = centre
 * These are container-independent and work directly as CSS object-position values.
 */
export interface ImagePositionState {
  x: number; // 0–100 percent, horizontal focal point
  y: number; // 0–100 percent, vertical focal point
}

export const DEFAULT_IMAGE_POSITION: ImagePositionState = {
  x: 50,
  y: 50,
};

/**
 * Aspect ratio constants that MUST be used consistently across:
 *  - The image-positioner selector (ib-web)
 *  - The preview containers (ib-itinerary-preview)
 *
 * Using the same aspect ratio in both ensures that object-fit:cover crops
 * the image identically, so object-position percentages map to the same
 * visible focal point.
 *
 * CSS usage: `[style.aspect-ratio]="IMAGE_ASPECT_RATIOS.DESTINATION"`
 * Tailwind:  `aspect-[1517/769]`  or  `aspect-video`
 */

/** Destination hero image – matches the preview-itinerary `aspect-[1517/769]` container */
export const DESTINATION_ASPECT_RATIO = '1517 / 769';

/** Destination image – numeric width/height for calculations */
export const DESTINATION_ASPECT_WIDTH = 1517;
export const DESTINATION_ASPECT_HEIGHT = 769;

/** Experience / activity images – 16:9 landscape ratio */
export const EXPERIENCE_ASPECT_RATIO = '16 / 9';

/** Experience image – numeric width/height for calculations */
export const EXPERIENCE_ASPECT_WIDTH = 16;
export const EXPERIENCE_ASPECT_HEIGHT = 9;